import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IActionPartner,
  IPeriodoUltimos12Meses,
  IPeriodoUltimos12MesesParnter,
} from './interfaces/apiInterfaces';
import { IInitialState, ILastTwelveMonths } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  domicilioSent: {
    value: 0,
    quantity: 0,
  },
  domicilioReceived: {
    value: 0,
    quantity: 0,
  },
  lastTwelveMonths: [],
};

export const getDomicilioFaresFromApi = createAction(
  '@faresApp/domicilioFares/GET_DOMICILIO_FARES_FROM_API'
);

export const gotDomicilioFaresFromApi = createAction<any>(
  '@faresApp/domicilioFares/GOT_DOMICILIO_FARES_FROM_API'
);

export const gotDomicilioFaresPartnerFromApi = createAction<any>(
  '@faresApp/domicilioFares/GOT_DOMICILIO_FARES_PARTNER_FROM_API'
);

export const gotErrorFromDomicilioFaresApi = createAction(
  '@faresApp/domicilioFares/GOT_ERROR_FROM_DOMICILIO_FARES_API'
);

export const displayDomicilioFares = createAction<boolean>(
  '@faresApp/domicilioFares/DISPLAY_DOMICILIO_FARES'
);

export const logoutDomicilioFaresApp = createAction(
  '@faresApp/domicilioFares/LOGOUT_DOMICILIO_FARES_APP'
);

const domicilioFaresReducer = createReducer(INITIAL_STATE, {
  [getDomicilioFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
    partner: false,
  }),
  [gotDomicilioFaresPartnerFromApi.type]: (state, action: IActionPartner) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: true,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    domicilioSent: {
      value: action.payload.domicilio_enviada.valor,
      quantity: action.payload.domicilio_enviada.quantidade,
    },
    domicilioReceived: {
      value: action.payload.domicilio_recebida.valor,
      quantity: action.payload.domicilio_recebida.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12MesesParnter) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.domicilio_enviada.valor,
            quantity: mes.domicilio_enviada.quantidade,
          },
          faresReceived: {
            value: mes.domicilio_recebida.valor,
            quantity: mes.domicilio_recebida.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotDomicilioFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    domicilioSent: {
      value: action.payload.fiducia_clientes_enviadas.valor,
      quantity: action.payload.fiducia_clientes_enviadas.quantidade,
    },
    domicilioReceived: {
      value: action.payload.fiducia_wl_recebidos.valor,
      quantity: action.payload.fiducia_wl_recebidos.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12Meses) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.fiducia_clientes_enviadas.valor,
            quantity: mes.fiducia_clientes_enviadas.quantidade,
          },
          faresReceived: {
            value: mes.fiducia_wl_recebidos.valor,
            quantity: mes.fiducia_wl_recebidos.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotErrorFromDomicilioFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
    partner: false,
  }),
  [displayDomicilioFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutDomicilioFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    partner: false,
    dateSearch: {
      start: '',
      end: '',
    },
  }),
});

export default domicilioFaresReducer;
